import { Tooltip } from 'platform/components';
import { Icon } from 'platform/foundation-tw';
import { match } from 'ts-pattern';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getTooltipProps } from '../../utils/getTooltipProps';
type CheckboxCellRendererProps = CellRendererProps<boolean | null> & {
  getTooltipProps?: TooltipGetter;
};
export function CheckboxCellRenderer(props: CheckboxCellRendererProps) {
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  const isTruthy = !!props.value;
  return <Tooltip {...tooltipProps}>
      <span style={{
      display: 'inline-flex'
    }}>
        {match(isTruthy).with(true, () => <Icon value="action/check_circle" size={6} color="severity.success" />).otherwise(() => <Icon value="navigation/cancel" size={6} color="severity.danger" />)}
      </span>
    </Tooltip>;
}